import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import '@/components/MobileCenteredLayout/MobileCenteredLayout.sass';

type MobileCenteredLayoutProps = {
  children: ReactNode;
};

export function MobileCenteredLayout({ children }: MobileCenteredLayoutProps) {
  return (
    <Box className="mobile-centered-layout">
      <Box
        className="mobile-centered-layout__inner"
        data-testid="mobile-centered-layout"
      >
        {children}
      </Box>
    </Box>
  );
}
